module.exports = __webpack_public_path__ + "static/img/far2_active.5ca313db.png";